import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Mascota } from '../models/mascota.model';

@Injectable({
  providedIn: 'root'
})
export class MascotasService {
  // 1. Inicializamos con un array vacío [] en lugar de null
  private mascotasSubject = new BehaviorSubject<Mascota[]>([]);
  mascotas$ = this.mascotasSubject.asObservable();

  constructor() { }

  // 2. Ahora recibe y emite un array completo de mascotas
  setMascotas(mascotas: Mascota[]) {
    this.mascotasSubject.next(mascotas);
  }

  // 3. Devuelve el array actual almacenado en el Subject
  getMascotas(): Mascota[] {
    return this.mascotasSubject.value;
  }

  /**
   * 💡 Tip Extra: Agregar una sola mascota al array existente de forma reactiva
   */
  agregarMascota(nuevaMascota: Mascota) {
    const listaActual = this.getMascotas();
    // Usamos el spread operator que vimos antes para añadirla al principio
    this.setMascotas([nuevaMascota, ...listaActual]);
  }

}